import { OnInit, Optional, Inject } from '@angular/core';
import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { IContextService, DomainContext, PershingTranslationService} from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiContextUtils } from '@pershing/nxi-common';
declare let dojoApp: any;
@Component({
    selector: 'history-filter',
    templateUrl: './dojo-historyFilter.component.html'
})
export class DojoHistoryFilterComponent implements OnInit, AfterViewInit {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    widgetparams: any;
    acctRef: string;
    qaInternalUrl: any;
    ismobile: boolean = false;
    checked: boolean = false;
    topicSubHandle: any = null;
    // private qaInternalUrl = 'https://qa-netxinvestor-internal.test.bnymellon.net/test-netxinvestor-rest-service-qa-app';
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                private nxiRestService: NxiRestService,
                private paramService: NxiWidgetParamsService,
                @Optional() @Inject('AppSettings') appSettings: any) {
                    if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
                        this.ismobile = true;
                    }
                    this.qaInternalUrl = this.nxiRestService.serviceUrl;
    }
    getWidgetResponse(acctresp: string): any {
        this.paramService.getWidgetParams(acctresp, 'historyFilter').subscribe(
      resp => {
        let response: any = resp.response;
        resp.response.storeUrl = this.qaInternalUrl + resp.response.storeUrl;
        // resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
        response.nxiRestServiceUrl = this.qaInternalUrl;
        console.log('response', response);
        if (dojoApp) {
            dojoApp.renderHistoryFilter(response);
        }
        // return response;
      },
     error => {
        if (dojoApp) {
            dojoApp.renderHistoryFilter();
        }
        return error;
      }
    );
  }
    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.widgetparams = this.getWidgetResponse(this.acctRef) ;
        });

    }
   ngAfterViewInit(): void {
        if (this.ismobile) {
            document.getElementById('historyFilter-grid').style.opacity = '0';
            document.getElementById('historyFilter-grid').style.height = '0';
            document.getElementById('filterSection').style.display = 'none';
            if (window['require']) {
                let topic = window['require']('dojo/topic');
                let lang = window['require']('dojo/_base/lang');
                this.topicSubHandle = topic.subscribe('/grid/query', lang.hitch(this, this.handleQueryEvent));
            }
        }
    }

    handleHistoryFilter(event: any): void {
        console.log(event.checked);
        if (event.checked) {
            console.log('inside true');
            document.getElementById('historyFilter-grid').style.opacity = '1';
            document.getElementById('historyFilter-grid').style.height = 'auto';
            document.getElementById('filterSection').style.display = 'block';
        } else {
            document.getElementById('historyFilter-grid').style.opacity = '0';
            document.getElementById('historyFilter-grid').style.height = '0';
            document.getElementById('filterSection').style.display = 'none';
            console.log('inside false');
        }
    }

    handleQueryEvent(): void {
        this.checked = false;
        this.handleHistoryFilter({checked: false});
    }
    ngOnDestroy(): void {
        console.log('In dojo historyFilter destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (this.topicSubHandle) {
            this.topicSubHandle.remove();
            this.topicSubHandle = null;
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyHistoryFilter();
        }
    }
}
